import { writable } from 'svelte/store';

export const audioWaveformState = writable({
    zoom : 1,
    multiplier : 1
});